var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1724(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#058998"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 16.5625H31.1266L29.5293 14.1672C29.4437 14.0389 29.3278 13.9338 29.1919 13.861C29.056 13.7882 28.9042 13.7501 28.75 13.75H21.25C21.0958 13.7501 20.944 13.7882 20.8081 13.861C20.6722 13.9338 20.5563 14.0389 20.4707 14.1672L18.8723 16.5625H15.625C14.8791 16.5625 14.1637 16.8588 13.6363 17.3863C13.1088 17.9137 12.8125 18.6291 12.8125 19.375V32.5C12.8125 33.2459 13.1088 33.9613 13.6363 34.4887C14.1637 35.0162 14.8791 35.3125 15.625 35.3125H34.375C35.1209 35.3125 35.8363 35.0162 36.3637 34.4887C36.8912 33.9613 37.1875 33.2459 37.1875 32.5V19.375C37.1875 18.6291 36.8912 17.9137 36.3637 17.3863C35.8363 16.8588 35.1209 16.5625 34.375 16.5625ZM29.2188 25.4688C29.2188 26.3031 28.9713 27.1188 28.5078 27.8126C28.0442 28.5063 27.3853 29.0471 26.6144 29.3664C25.8436 29.6857 24.9953 29.7692 24.177 29.6064C23.3586 29.4437 22.6069 29.0419 22.0169 28.4519C21.4269 27.8619 21.0251 27.1101 20.8623 26.2918C20.6995 25.4734 20.7831 24.6252 21.1024 23.8543C21.4217 23.0834 21.9624 22.4246 22.6562 21.961C23.35 21.4974 24.1656 21.25 25 21.25C26.1189 21.25 27.1919 21.6945 27.9831 22.4856C28.7743 23.2768 29.2188 24.3499 29.2188 25.4688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1724);
export default __webpack_public_path__ + "static/media/Group 1724.2423511019b279027f72c2482861d47f.svg";
export { ForwardRef as ReactComponent };